import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class ItemRevisionGeneration extends Model<Schemas['itemRevisionGenerations'], Models> {
    get finishedAtDate() {
        return nullableDate(this.finishedAt);
    }
}
